// extracted by mini-css-extract-plugin
module.exports = {"root":"description_root__cZ9Wq","bottom":"description_bottom__97_7B"};